const POPUP_WIDTH = 500
const POPUP_HEIGHT = 620
const POLLING_INTERVAL = 300
const POLLING_TIMEOUT = 300000 // 5 minutos

// returnTo: destino pós-login quando o popup é bloqueado e a página inteira sai
// para o Google (o GoogleCallback consome sessionStorage.google_return_to no modo redirect)
export function openGooglePopup(onSuccess, onError, returnTo) {
  const left = window.screenX + (window.outerWidth - POPUP_WIDTH) / 2
  const top = window.screenY + (window.outerHeight - POPUP_HEIGHT) / 2
  const url = `${process.env.REACT_APP_APPSETTING_SM_AUTH_API_ENDPOINT}/auth/google`

  const popup = window.open(
    url,
    'google-auth-popup',
    `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},resizable=yes,scrollbars=yes`
  )

  if (!popup) {
    // Popup bloqueado: redireciona diretamente para o login Google na janela principal
    // (sem returnTo, limpa um destino antigo de uma tentativa abandonada). Em
    // sessionStorage: sobrevive à ida ao Google na mesma aba, e o localStorage é
    // limpo no boot sem sessão (REHYDRATE → destroy)
    try {
      if (returnTo) sessionStorage.setItem('google_return_to', returnTo)
      else sessionStorage.removeItem('google_return_to')
    } catch (e) {
      /* storage indisponível: o callback usa o destino padrão */
    }
    window.location.href = url
    return
  }

  // Cria um ID único para esta sessão de autenticação
  const authId = `google_auth_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  const storageKey = `google_auth_result_${authId}`
  
  // Salva o authId em um local que o popup conseguirá acessar
  sessionStorage.setItem('google_auth_pending', authId)
  // Também deixa uma "marca" persistente que o popup poderá encontrar
  localStorage.setItem('google_auth_pending_id', authId)

  console.log('Google Auth: iniciando com authId:', authId)

  let pollingTimer = null
  let timeoutTimer = null
  let cleaned = false

  // Faz polling no localStorage para detectar resultado (funciona com COOP)
  function startPolling() {
    const startTime = Date.now()
    
    pollingTimer = setInterval(() => {
      const result = localStorage.getItem(storageKey)
      
      if (result) {
        console.log('Google Auth: resultado encontrado no localStorage')
        try {
          const data = JSON.parse(result)
          localStorage.removeItem(storageKey)
          cleanup()
          
          if (data.success) {
            console.log('Google Auth: autenticação bem-sucedida')
            onSuccess && onSuccess(data.token, data.user)
          } else {
            console.error('Google Auth: erro na autenticação', data.error)
            onError && onError(new Error(data.error || 'Erro ao autenticar com Google'))
          }
        } catch (e) {
          console.error('Erro ao processar resultado do localStorage:', e)
          cleanup()
          onError && onError(new Error('Erro ao processar autenticação'))
        }
        return
      }

      // Timeout
      if (Date.now() - startTime > POLLING_TIMEOUT) {
        console.warn('Google Auth: timeout aguardando resposta')
        cleanup()
      }
    }, POLLING_INTERVAL)
  }

  // Tenta usar postMessage também (funciona se não houver COOP)
  function handleMessage(event) {
    if (event.origin !== window.location.origin) return
    if (!event.data || event.data.type !== 'GOOGLE_AUTH_SUCCESS') return
    
    console.log('Google Auth: sucesso via postMessage')
    cleanup()
    onSuccess && onSuccess(event.data.token, event.data.user)
  }

  function handleError(event) {
    if (event.origin !== window.location.origin) return
    if (!event.data || event.data.type !== 'GOOGLE_AUTH_ERROR') return
    
    console.error('Google Auth: erro via postMessage', event.data.message)
    cleanup()
    onError && onError(new Error(event.data.message || 'Erro ao autenticar com Google'))
  }

  function cleanup() {
    if (cleaned) return
    cleaned = true
    
    console.log('Google Auth: limpando recursos')
    window.removeEventListener('message', handleMessage)
    window.removeEventListener('message', handleError)
    
    if (pollingTimer) clearInterval(pollingTimer)
    if (timeoutTimer) clearTimeout(timeoutTimer)
    
    sessionStorage.removeItem('google_auth_pending')
    localStorage.removeItem('google_auth_pending_id')
    localStorage.removeItem(storageKey)
  }

  // Configura listeners
  window.addEventListener('message', handleMessage)
  window.addEventListener('message', handleError)
  
  // Inicia polling
  startPolling()
  
  // Timeout de segurança
  timeoutTimer = setTimeout(() => {
    console.warn('Google Auth: timeout geral')
    cleanup()
  }, POLLING_TIMEOUT)
}

